import React, { useState } from 'react';
import { navigate, useStaticQuery, graphql } from 'gatsby';
import slug from 'slug';
import styled from 'styled-components';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { SpinnerCircular } from 'spinners-react';
import * as Yup from 'yup';
import * as Sentry from '@sentry/gatsby';
// import 'yup-phone';

const DevisSchema = Yup.object().shape({
  prestation: Yup.string().required(),
  canton: Yup.string().required(),
  phone: Yup.string().required('Le numéro de téléphone est requis'),
  // .phone(
  //   'CH',
  //   true,
  //   'Numéro de téléphone invalide (seuls les numéros venant de Suisse sont autorisés)'
  // ),
  email: Yup.string().email().required('Email est requis'),
  message: Yup.string()
    .required('Le message est requis')
    .min(6, 'Votre message est trop court')
    .max(200, 'Votre message est trop long'),
});

const initialState = {
  prestation: 'Ouverture porte claquée',
  canton: 'Vaud',
  phone: '',
  email: '',
  message: '',
};

export default function FormDevis({ tarifs }) {
  const data = useStaticQuery(graphql`
    query getPrestations {
      allPrestationsTarifsJson {
        edges {
          node {
            title
            prestations
            prix
            slug
          }
        }
      }
    }
  `);
  const [loading, setLoading] = useState(false);
  const [prestationTitle, setPrestation] = useState('ouverture-porte-claquee');
  const [contonName, setConton] = useState('Vaud');
  const handleSubmit = (values, { setSubmitting }) => {
    const { phone, email, message } = values;
    setLoading(true);

    for (const tarif of data.allPrestationsTarifsJson.edges) {
      if (tarif.node.slug === prestationTitle) {
        const data = JSON.stringify({
          title: prestationTitle,
          canton: contonName,
          phone,
          email,
          message,
          prix: tarif.node.prix,
          prestations: tarif.node.prestations,
        });
        fetch('https://super-serrurier.vercel.app/api/get_devis', {
          method: 'POST',
          body: data,
        })
          .then((response) => {
            if (response.status === 200) {
              setLoading(false);
              setSubmitting(false);
              navigate(`/tarifs/${contonName}/${slug(prestationTitle)}`);
            } else {
              setSubmitting(false);
              setLoading(false);
              Sentry.captureException(
                new Error(
                  '[Cannot redirect: /api/get_devis]: Encountered a problem when trying to redirect to the pricing page'
                )
              );
            }
          })
          .catch((err) => {
            setSubmitting(false);
            setLoading(false);
            Sentry.captureException(
              new Error('[Error: /api/get_devis]: ' + err)
            );
          });
      }
    }
  };
  return (
    <div>
      <h2 className="text-2xl lg:text-1xl xl:text-2xl md:block mt-3 text-gray-600 text-center font-extrabold">
        Remplissez le formulaire pour obtenir un devis instantané
      </h2>
      <div className="mt-6 relative mb-4">
        <div
          className="absolute inset-0 flex items-center justify-center"
          aria-hidden="true"
        >
          <div className="w-1/2 border-t border-gray-300"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500"></span>
        </div>
      </div>
      <Formik
        initialValues={initialState}
        validationSchema={DevisSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="grid grid-cols-1 gap-y-6">
            <div>
              <label htmlFor="prestations " className="sr-only">
                Prestations
              </label>
              <Select
                id="prestations"
                name="location"
                onChange={(e) => {
                  setPrestation(e.currentTarget.value);
                }}
                className="custom-select w-full text-base border-gray-300 focus:outline-none focus:ring-primarycolor focus:border-primarycolor sm:text-sm rounded-md"
              >
                <option value="ouverture-porte-claquee">
                  Ouverture porte claquée{' '}
                </option>
                <option value="ouverture-porte-fermee-a-clef">
                  Ouverture porte fermée à clef
                </option>
                <option value="ouverture-porte-blindee-fermee-a-clef">
                  Ouverture porte blindée fermée à clef
                </option>
                <option value="reglage-de-porte">Réglage de porte</option>
                <option value="remplacement-de-cylindre">
                  Remplacement de cylindre
                </option>
                <option value="changement-de-serrure">
                  Changement de serrure{' '}
                </option>
              </Select>
            </div>

            <div>
              <label htmlFor="cantons " className="sr-only">
                Prestations
              </label>
              <Field
                as="select"
                name="canton"
                onChange={(e) => {
                  setConton(e.currentTarget.value);
                  console.log(e.currentTarget.value);
                }}
                className="custom-select w-full text-base border-gray-300 focus:outline-none focus:ring-primarycolor focus:border-primarycolor sm:text-sm rounded-md"
              >
                <option value="Vaud">Vaud</option>
                <option value="Genève">Genève</option>
                <option value="Fribourg">Fribourg</option>
                <option value="Neuchâtel">Neuchâtel</option>
                <option value="Valais">Valais</option>
              </Field>
            </div>

            <div>
              <label htmlFor="phone" className="sr-only">
                Phone
              </label>
              <Field
                required
                type="text"
                name="phone"
                className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                placeholder="Phone"
              />
              <ErrorMessage
                className="text-red-500 text-sm mt-2"
                name="phone"
                component="div"
              />
            </div>
            <div>
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <Field
                name="email"
                type="email"
                className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                placeholder="Email"
              />
              <ErrorMessage
                className="text-red-500 text-sm mt-2"
                name="email"
                component="div"
              />
            </div>
            <div>
              <label htmlFor="message" className="sr-only">
                Message
              </label>
              <Field
                required
                name="message"
                as="textarea"
                rows="4"
                className="block resize-none w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                placeholder="Message"
              />
              <ErrorMessage
                className="text-red-500 text-sm mt-2"
                name="message"
                component="div"
              />
            </div>
            <div>
              <button
                type="submit"
                className="inline-flex justify-center py-3 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-primarycolor hover:bg-primarycolor-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                disabled={isSubmitting}
              >
                Obtenir mon devis
                <SpinnerCircular
                  enabled={loading}
                  style={{ color: '#fff', marginLeft: '5px' }}
                  size={25}
                />
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

const Select = styled.select`
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  padding-left: 1rem;
  padding-right: 2rem;
`;
